<template>
  <div id="app">
    <!-- <router-view @contextmenu.prevent /> -->
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl:process.env.VUE_APP_WEB_BASE_URL,
    };
  },
  mounted() {
    window.onload = function () {
      if (!window.sessionStorage["ISlogin"]) {
        // 关闭浏览器
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("userName");
      } else {
        // 刷新
      }
    };
    window.onunload = function () {
      window.sessionStorage["ISlogin"] = true;
    };
    window.onbeforeunload = function () {
      window.sessionStorage["ISlogin"] = true;
    };
    // 禁止按F12
    document.onkeydown = function (e) {
      if (e && e.keyCode === 123) {
        e.returnValue = false
        return false
      }
    }
    // 禁止右键打开
    document.oncontextmenu=function(){return false;}
    // 禁止选中
    document.onselectstart=function(){return false;}
  },
  methods:{
    // checkWindowHeight() {
    //   if(window.outerHeight - window.innerHeight > 150)  {
    //     window.close()
    //     window.location.href = this.baseUrl
    //   }
    // }
  }
};
</script>
<style lang="scss">
#app {
    font-size: 16px!important;

  router-view {
    width: 100%;
  }
}
.el-popover {
  .tel {
    color: #ed201a !important;
  }
}
</style>
